import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from 'src/utils/UserContext';
import ApplicationRoutes from 'src/core/routing/ApplicationRoutes';
import AppInitWrapper from './components/AppInitWrapper';
import AuthenticationWrapper from './utils/AuthenticationWrapper';


import '@amzn/katal-components/styles.css';
import './index.scss';
import './core/styles/coreStyles.css';
// Create QueryClient outside of component to ensure it's not recreated on renders
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            staleTime: 300000, // 5 minutes
            cacheTime: 3600000, // 1 hour
            suspense: false,
        },
    },
});

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <UserProvider>
                <BrowserRouter>
                    <AuthenticationWrapper>
                        <AppInitWrapper>
                            <ApplicationRoutes />
                        </AppInitWrapper>
                    </AuthenticationWrapper>
                </BrowserRouter>
            </UserProvider>
        </QueryClientProvider>
    );
}

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');



const root = createRoot(container);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
